import React, { useState } from "react";
import useNavigation from "../GoToRoute/useNavigation";
import styles from "./styles.module.css";

export default function FilterIcon({
  name,
  id,
  enable,
  setFilterId,
  redirectTo,
  onMouseMove,
}) {
  return (
    <div
      onClick={() => {
        setFilterId(name);
      }}
      className={styles.container + " " + (enable ? styles.enable : "")}
    >
      {name}
    </div>
  );
}
